import styled from 'styled-components';

const DefaultButton = styled.button`
  background: var(--primary-color);
  color: white;
  outline: none;
  border: none;
  cursor: pointer;
  font-size: var(--font-small);
  font-weight: bold;
  border-radius: 5px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 4px 6px rgba(50, 50, 93, 0.1);
  display: flex;
  align-items: center;
  gap: 5px;

  &.danger {
    background: var(--danger-color);
  }

  &.success {
    background: var(--success-color);
  }

  &.info {
    background: var(--info-color);
  }

  &.white {
    background: white;
    color: #444;
    border: solid 1px var(--default-dark-gray);
  }

  &.warning {
    background: #ffc107;
    color: black;
  }
  
  &:not(.small) {
    padding: 15px 20px;
  }

  &.small {
    padding: 3px 6px;
    max-height: 45px;
  }

  &.medium {
    padding: 10px;
    max-height: 60px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default DefaultButton;
